export const IMG_W = 1024;
export const IMG_H = 1536;
export const FLYER_SRC = "/assets/ironbowl_board.png";
export const COLS = [28, 100.5, 173.5, 247.5, 320, 392.5, 465, 537.5, 608.5, 681.5, 747];
export const ROWS = [601, 671.5, 736, 799, 861.5, 925.5, 989.5, 1051, 1113.5, 1176, 1243];

export function cellRect(num) {
  const c = (num - 1) % 10;
  const r = Math.floor((num - 1) / 10);
  return { x: COLS[c], y: ROWS[r], w: COLS[c + 1] - COLS[c], h: ROWS[r + 1] - ROWS[r] };
}

function wrapName(ctx, text, maxW) {
  const words = text.split(/\s+/);
  const lines = [""];
  words.forEach((w) => {
    const cur = lines[lines.length - 1];
    const next = cur ? `${cur} ${w}` : w;
    if (ctx.measureText(next).width <= maxW || !cur) lines[lines.length - 1] = next;
    else lines.push(w);
  });
  return lines.slice(0, 2);
}

export async function renderBoardImage(board, footerText) {
  await document.fonts.load("700 30px 'Barlow Condensed'");
  const img = new Image();
  img.src = FLYER_SRC;
  await img.decode();
  const FOOT = footerText ? 110 : 0;
  const canvas = document.createElement("canvas");
  canvas.width = IMG_W;
  canvas.height = IMG_H + FOOT;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, IMG_W, IMG_H);
  const winners = Object.values(board.winners || {}).filter((n) => n != null);
  ctx.textAlign = "center";
  board.squares.forEach((sq) => {
    const { x, y, w, h } = cellRect(sq.number);
    const sold = sq.status === "sold";
    ctx.fillStyle = sold ? "#f3c649" : "#ffffff";
    ctx.fillRect(x + 3, y + 3, w - 6, h - 6);
    if (winners.includes(sq.number)) {
      ctx.strokeStyle = "#c4473d"; ctx.lineWidth = 5;
      ctx.strokeRect(x + 5, y + 5, w - 10, h - 10);
    }
    ctx.fillStyle = "#000000";
    ctx.font = "700 27px 'Barlow Condensed', Arial, sans-serif";
    ctx.fillText(String(sq.number), x + w / 2, y + 30);
    if (sold) {
      ctx.font = "700 20px 'Barlow Condensed', Arial, sans-serif";
      const lines = wrapName(ctx, (sq.name || "SOLD").toUpperCase(), w - 8);
      lines.forEach((ln, i) => ctx.fillText(ln, x + w / 2, y + h - 10 - (lines.length - 1 - i) * 19, w - 6));
    }
  });
  if (FOOT) {
    ctx.fillStyle = "#0b0a09";
    ctx.fillRect(0, IMG_H, IMG_W, FOOT);
    ctx.fillStyle = "#f3c649";
    ctx.font = "700 30px 'Barlow Condensed', Arial, sans-serif";
    ctx.fillText(`${board.squares.length - board.stats.sold} SQUARES LEFT · GRAB YOURS AT`, IMG_W / 2, IMG_H + 44);
    ctx.fillStyle = "#ffffff";
    ctx.font = "700 34px 'Barlow Condensed', Arial, sans-serif";
    ctx.fillText(footerText, IMG_W / 2, IMG_H + 88, IMG_W - 40);
  }
  return new Promise((res) => canvas.toBlob(res, "image/png"));
}
